/* Layout */
import Layout from '@/layout'

/* Router Modules */
const spaceRouter = {
  path: '/space',
  component: Layout,
  name: 'space',
  redirect: '/space',
  meta: {
    title: '空间展示应用'
  },
  children: [
    {
      path: '/space',
      component: () => import('@/views/space/index'),
      name: 'space',
      meta: { title: '空间展示应用', affix: true, projectId: 3 }
    },
    {
      path: '/space/detail',
      component: () => import('@/views/space/detail'),
      name: 'SpaceDetail',
      hidden: true,
      meta: { title: '方案详情', affix: true, projectId: 2, guidePath: true, jumpPath: '/space' }
    },
    {
      path: '/space/collect',
      component: () => import('@/views/space/collect'),
      name: 'SpaceCollect',
      hidden: true,
      meta: { title: '需求汇总', affix: true, projectId: 2, guidePath: true, jumpPath: '/space' }
    }
  ]
}

export default spaceRouter
